"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TenantListActions;
(function (TenantListActions) {
    TenantListActions["DataLoaded"] = "DataLoaded";
    TenantListActions["ActiveTenantChanged"] = "ActiveTenantChanged";
})(TenantListActions || (TenantListActions = {}));
exports.default = TenantListActions;
